export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function timeout<T>(promise: Promise<T>, ms: number) {
  return Promise.race([promise, delay(ms).then(() => Promise.reject(new Error('Operation timed out')))]);
}
